import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {ServerProvider} from "../../providers/server/server";
import {Observable} from "rxjs/Observable";

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  username;
  password;

  constructor(public navCtrl: NavController, public navParams: NavParams, public server: ServerProvider, public viewCtrl: ViewController) {

  }

  login(){
    this.server.post( 'login', { username: this.username, password: this.password } ).subscribe( (data:any)=>{
      localStorage.setItem('token', data.data.token );
      this.server.setHeaders();
      this.server.token = data.data.token;
      this.server.user = data.data
      this.viewCtrl.dismiss();
      this.server.getCases();
    }, err=>{
      console.log(err);
      alert( "Error logging in. Please try again." );
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts